// Detect embedded/in-app webviews (Facebook, Instagram, and other social apps)
// where popup-based OAuth is broken. Google and Microsoft sign-in open a popup,
// which these webviews either block or reject — Google returns "this browser or
// app may not be secure." A huge share of our traffic arrives from Facebook and
// lands in FB's in-app browser, so we hide those buttons there and let people
// use email (or open in a real browser) instead of tapping a button that fails.
export function isInAppBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || navigator.vendor || "";
  // FBAN/FBAV = Facebook app; Instagram = IG app; others are common social/webview shells.
  return /\b(FBAN|FBAV|FB_IAB|Instagram|Line|Snapchat|Pinterest|TikTok|musical_ly)\b/i.test(ua);
}
